import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import DriverStoriesSection from '../components/DriverStoriesSection';
import { IndianRupee, Clock, Car, TrendingUp, Shield, Users } from 'lucide-react';

const DriveWithUsPage = () => {
  const benefits = [
    {
      icon: <IndianRupee size={24} />,
      title: 'Earn More',
      description: 'Competitive earnings with weekly payouts and attractive bonus schemes'
    },
    {
      icon: <Clock size={24} />,
      title: 'Flexible Hours',
      description: 'Choose your own schedule and work at your convenience'
    },
    {
      icon: <Car size={24} />,
      title: 'Zero Ownership Cost',
      description: 'No vehicle? No problem! Drive our electric autos with no upfront investment'
    },
    {
      icon: <TrendingUp size={24} />,
      title: 'Growth Opportunities',
      description: 'Access to training programs and career advancement opportunities'
    },
    {
      icon: <Shield size={24} />,
      title: 'Insurance Coverage',
      description: 'Comprehensive insurance coverage for all driver-partners'
    },
    {
      icon: <Users size={24} />,
      title: 'Community Support',
      description: 'Join a supportive community of drivers and get 24/7 assistance'
    }
  ];

  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      
      {/* Hero Section - Left aligned with image on right */}
      <section className="pt-32 pb-4 bg-black text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            {/* Left - Content */}
            <div className="text-left">
              <h1 className="text-5xl md:text-6xl font-bold mb-6">Drive with Nura</h1>
              <p className="text-xl text-gray-300 mb-8">
                Join our community of pilots and be part of the electric mobility revolution. Earn well, work flexibly, and make a positive impact.
              </p>
              <a
                href="https://wa.me/message/XZDIURMRKZIGD1"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-[#bceb39] text-black font-bold py-4 px-8 rounded-lg hover:bg-[#a8d632] transition-colors duration-300 text-lg"
              >
                Apply Now on WhatsApp
              </a>
            </div>
            
            {/* Right - Auto Image on black background - 75% larger, moved left */}
            <div className="flex justify-start bg-black">
              <img
                src="https://customer-assets.emergentagent.com/job_green-ride-2/artifacts/pfxsdg7m_ChatGPT%20Image%20Feb%203%2C%202026%2C%2012_12_26%20AM.png"
                alt="NURA Electric Auto"
                className="w-full max-w-2xl h-auto scale-110"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Grid - Compact cards with new layout */}
      <section className="py-5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="bg-gray-900 p-5 rounded-xl border border-gray-800 hover:border-[#bceb39] transition-all duration-300"
              >
                {/* Row 1: Icon + Title */}
                <div className="flex items-center gap-4 mb-3">
                  <div className="w-10 h-10 bg-[#bceb39] rounded-full flex items-center justify-center text-black flex-shrink-0">
                    {benefit.icon}
                  </div>
                  <h3 className="text-lg font-bold text-white">{benefit.title}</h3>
                </div>
                {/* Row 2: Description */}
                <p className="text-gray-400 text-sm">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Driver Stories Section */}
      <DriverStoriesSection />

      {/* Requirements Section - Two Column Layout */}
      <section className="py-12 bg-gray-900">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-center mb-10 text-white">Requirements</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Basic Requirements - Left */}
            <div className="bg-black p-6 rounded-xl border border-gray-800 h-full">
              <h3 className="text-2xl font-bold mb-4 text-white">Basic Requirements</h3>
              <ul className="list-disc list-inside space-y-2 text-gray-300">
                <li>Valid driving license</li>
                <li>Age between 21-55 years</li>
                <li>Clean driving record</li>
                <li>Basic smartphone operation skills</li>
              </ul>
            </div>
            {/* Documents Needed - Right */}
            <div className="bg-black p-6 rounded-xl border border-gray-800 h-full">
              <h3 className="text-2xl font-bold mb-4 text-white">Documents Needed</h3>
              <ul className="list-disc list-inside space-y-2 text-gray-300">
                <li>Driving License (original & copy)</li>
                <li>Aadhaar Card</li>
                <li>PAN Card</li>
                <li>Bank Account Details</li>
                <li>Passport size photographs</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default DriveWithUsPage;
